import React, { PureComponent } from 'react'

import {
  Redirect,
  Switch
} from 'react-router-dom'
import { withRouter } from 'react-router'
import { headTitleTag } from '../../helpers/functions'

import fetchApiData from '../apiHandlers/fetchApiData'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import ReactDOM from 'react-dom'

import BodyClassName from 'react-body-classname'
import DealerBlock from '../DealerBlock/DealerBlock'
import DealerBlockLoader from '../DealerBlock/dealerBlockLoader'

import HappyHoureTitle from '../Titles/HappyHoureTitle'
import ShowMoreButton from '../buttons/showMoreButton'
import { connect } from 'react-redux'
import { CurrentStepSetAction } from '../../actions/action'
import CONSTANTS from '../../constants'
import './pagemapsolo.css'

import markerIconAP from '../../images/AP/pin-peugeot-map.png'
import markerIconActiveAP from '../../images/AP/pin-peugeot-hover.png'
import clusterIconAP from '../../images/AP/ap-pin-number.png'

import markerIconAC from '../../images/AC/pin-ac-defaut.svg'
import markerIconActiveAC from '../../images/AC/pin-ac-hover.svg'
import clusterIconAC from '../../images/AC/ac-pin-number.svg'

import markerIconDS from '../../images/DS/ds-pin-Small.png'
import markerIconActiveDS from '../../images/DS/ds-pin-Big-Hover.png'
import clusterIconDS from '../../images/DS/ds-pin-number.svg'

import markerIconOV from '../../images/OV/pin-ov-defaut.png'
import markerIconActiveOV from '../../images/OV/pin-ov-hover.png'
import clusterIconOV from '../../images/OV/ov-pin-number.png'

var _marker = new Object()
if (window.siteConfig.currentBrand === 'P') {
  _marker = {
    icon: markerIconAP,
    iconActive: markerIconActiveAP,
    iconCluster: clusterIconAP,
    size: (window.google.maps ? new window.google.maps.Size(80, 80) : false),
    scaledSize: (window.google.maps ? new window.google.maps.Size(80, 80) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  }
}
if (window.siteConfig.currentBrand === 'C') {
  _marker = {
    icon: markerIconAC,
    iconActive: markerIconActiveAC,
    iconCluster: clusterIconAC,
    size: (window.google.maps ? new window.google.maps.Size(91, 98) : false),
    scaledSize: (window.google.maps ? new window.google.maps.Size(91, 98) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  }
}
if (window.siteConfig.currentBrand === 'D') {
  _marker = {
    icon: markerIconDS,
    iconActive: markerIconActiveDS,
    iconCluster: clusterIconDS,
    size: (window.google.maps ? new window.google.maps.Size(50, 50) : false),
    scaledSize: (window.google.maps ? new window.google.maps.Size(50, 50) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  }
}

if (window.siteConfig.currentBrand === 'V') {
  _marker = {
    icon: markerIconOV,
    iconActive: markerIconActiveOV,
    iconCluster: clusterIconOV,
    size: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
    scaledSize: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  }
}

const google = window.google
var Gmap
const MyMapComponent = withGoogleMap(
  (props) =>
    <GoogleMap
      defaultZoom={10}
      ref={props.onMapMounted}
      defaultCenter={props.attDefaultCenter}
      options={props.attOptions}
    >
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        gridSize={80}
        maxZoom={9}
        styles={(window.siteConfig.currentBrand == 'P' ? [{ textColor: '#133d5f', fontFamily: 'Peugeot', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
          : (window.siteConfig.currentBrand == 'C' ? [{ textColor: '#fff', fontFamily: 'Ubuntu', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
            : (window.siteConfig.currentBrand == 'D' ? [{ textColor: '#fff', fontFamily: 'Roboto', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
              : [{ textColor: '#000', fontFamily: 'Opel', textSize: 14, height: 42, url: _marker.iconCluster, width: 42 }])))}
      >
        {props.children}
      </MarkerClusterer>
    </GoogleMap>
)
const mapStateToProps = state => state
const mapDispatchToProps = { CurrentStepSetAction }

class PageMapSolo extends PureComponent {
  constructor(props) {
    super(props)
    this.getDistanceBetweenPlaces = this.getDistanceBetweenPlaces.bind(this)
    this.showMore = this.showMore.bind(this)
    this.markerIsHover = this.markerIsHover.bind(this)
    this.markerNotHover = this.markerNotHover.bind(this)
    this.dealerIsHover = this.dealerIsHover.bind(this)
    this.state = {
      data: [],
      selectedData: [],
      isLoading: false,
      errorRedirect: false,
      pagination: 1,
      stickyMap: null,
      currentDealerData: [],
      map: {
        lat: Number(window.siteConfig.defaultCountryGeo.lat),
        lng: Number(window.siteConfig.defaultCountryGeo.lng)
      },
      clickedShowMore: false,
    }
    this._isMounted = false
  }

  componentDidMount() {
    this.props.CurrentStepSetAction(2)
    this.setState({ isLoading: true })
    this._isMounted = true

    const listDealers = new fetchApiData()
    listDealers.getListDealers().then(
      data => {

        if (this._isMounted) {
          this.setState({
            isLoading: false,
            data: data.d
          })
          this.setState({
            selectedData: Object.values(this.getDistanceBetweenPlaces(this.props)).slice(0, this.state.pagination)
          })
          if (!Object.values(this.state.currentDealerData).length) { this.setState({ errorRedirect: true }) }
        }
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false
        })
        console.error('fail', error)
      });


    // if a parametre in the url is undefined we do a redirection to the search page (dealer locator)
    Object.values(this.props.match.params).forEach(value => {
      if (value === undefined) {
        this.props.history.push(CONSTANTS.SITE_ROUTS.HOMEPAGE)
      }
    })
    const IdDealer = this.props.match.params.iddealer
    this.setState({ IdDealer: IdDealer })

    // GA Start
    // if it comes from homa page keep updatevirtuel path
    if (window.location.search.indexOf('referer')) {
      window.dataLayer.push({
        event: 'updatevirtualpath',
        brand: window.siteConfig.brandGTM,
        virtualPageURL: '/dealer-locator/solo-dealer',
        pageName: window.siteConfig.pageName,
        language: window.siteConfig.language,
        country: window.siteConfig.currentCountry,
        siteTypeLevel1: window.siteConfig.siteTypeLevel1,
        siteTypeLevel2: 'appointement',
        siteOwner: 'central',
        siteTarget: 'B2C',
        siteFamily: 'after-sales',
        pageCategory: 'dealer locator page'
      })
    } else {
      window.dataLayer.push({
        brand: window.siteConfig.brand,
        virtualPageURL: '/dealer-locator/solo-dealer',
        pageName: window.siteConfig.pageName,
        language: window.siteConfig.language,
        country: window.siteConfig.currentCountry,
        siteTypeLevel1: window.siteConfig.siteTypeLevel1,
        siteTypeLevel2: 'appointement',
        siteOwner: 'central',
        siteTarget: 'B2C',
        siteFamily: 'after-sales',
        pageCategory: 'dealer locator page'
      })
    }

    // GA Ends

    // On scroll get map sticked to top
    // adding class 'sticky-map to container'
    if (typeof document !== 'undefined') {
      window.addEventListener('scroll', (event) => {
        // old footer <900
        if (window.pageYOffset > 250 && window.pageYOffset < document.body.offsetHeight - 700 && window.isMobile() === 'desktop' && this.state.selectedData.length > 1) {
          this.setState({ stickyMap: 'sticky-map' })
        }
        else {
          this.setState({ stickyMap: '' })
        }

      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const IdDealer = Number(nextProps.match.params.iddealer)
    this.setState({ IdDealer: IdDealer })
    this.setState({
      selectedData: Object.values(this.getDistanceBetweenPlaces(nextProps)).slice(0, this.state.pagination)
    })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getDistanceBetweenPlaces(urlProps = this.props) {
    const IdDealer = urlProps.match.params.iddealer
    let dealers = Object.assign({}, this.state.data)
    let dealerKey = -1
    dealers = Object.values(dealers).map(function (dealer, key) {
      if (dealer.GeoId === IdDealer) { dealerKey = key }
      return dealer
    })
    if (dealers.length > 0 && dealerKey > -1) {
      this.setState({
        map: {
          lat: Number(dealers[dealerKey].Latitude),
          lng: Number(dealers[dealerKey].Longitude)
        },
        currentDealerData: dealers[dealerKey], pagination: 1
      })

      Gmap.panTo(new google.maps.LatLng(
        Number(dealers[dealerKey].Latitude),
        Number(dealers[dealerKey].Longitude)
      ))
    } else {
      this.setState({ currentDealerData: [], pagination: 0 })
    }

    dealers = Object.values(dealers).map(function (dealer, key) {
      dealer.IsHover = false
      const currentAdress = new google.maps.LatLng(this.state.map.lat, this.state.map.lng)
      const dealerLocation = new google.maps.LatLng(Number(dealer.Latitude), Number(dealer.Longitude))
      dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(7)
      return dealer
    }.bind(this))
    this.setState({
      data: dealers.sort(function (a, b) {
        return a.Distance - b.Distance
      })
    })
    return dealers.sort(function (a, b) {
      return a.Distance - b.Distance
    })
  }

  showMore() {
    this.setState({
      clickedShowMore: true,
      selectedData: this.state.data.slice(0, this.state.pagination + 4),
      pagination: this.state.pagination + 4,
    })
  }

  markerIsHover(id) {
    const dealers = Object.assign({}, this.state.selectedData)
    for (var i = 0; i < Object.keys(dealers).length; i++) {
      if (dealers[i].DealerId === id) {
        dealers[i].IsHover = true
      }
    }

    this.setState({
      selectedData: Object.values(dealers)
    })
  }

  dealerIsHover(id) {
    const dealers = Object.assign({}, this.state.selectedData)
    let selectedDealer = []
    for (var i = 0; i < Object.keys(dealers).length; i++) {
      if (dealers[i].DealerId === id) {
        dealers[i].IsHover = true
        selectedDealer = dealers[i]
      }
    }
    this.setState({
      selectedData: Object.values(dealers)
    })
    Gmap.panTo(new google.maps.LatLng(Number(selectedDealer.Latitude), Number(selectedDealer.Longitude)))
  }

  markerNotHover() {
    const dealers = Object.assign({}, this.state.selectedData)
    for (var i = 0; i < Object.keys(dealers).length; i++) {
      dealers[i].IsHover = false
    }

    this.setState({ selectedData: Object.values(dealers) })
  }

  handleScrollToElement(idDealer) {
    const d = ReactDOM.findDOMNode(this.refs['id' + idDealer])
    d.focus()
    window.scrollTo(0, d.offsetTop)
  }

  handleMapMounted(map) {
    Gmap = map
  }

  render() {
    const SEO_TITLE = (window.siteConfig.v2solodealer != undefined ? window.siteConfig.v2solodealer.Title : '')
    const SEO_DESC = (window.siteConfig.v2solodealer != undefined ? window.siteConfig.v2solodealer.MetaDescription : '')

    const happyHoureMessage = (window.innerWidth <= 800 ? CONSTANTS.LABELS.multislots_happy_hours_mobile : CONSTANTS.LABELS.multislots_happy_hours_desktop)
    const isHappuHoureMessageEnabled = (happyHoureMessage.length > 2)

    return (
      <div className='content-wrapper container-full-content'>
        <BodyClassName className='page--soloDealer' />
        {
          (this.state.currentDealerData != null && !!Object.values(this.state.currentDealerData).length) &&
          headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_garage]', this.state.currentDealerData.Name.toUpperCase()).replace('[nom_ville]', this.state.currentDealerData.City.toUpperCase()),
            SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_garage]', this.state.currentDealerData.Name.toUpperCase()).replace('[nom_ville]', this.state.currentDealerData.City.toUpperCase()))

        }

        {((this.state.data.length < 1) && this.state.errorRedirect) &&
          <Switch>
            <Redirect exact to='/404' />
          </Switch>}

        {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <p tabIndex="0" className='content-headline'>
          {CONSTANTS.LABELS.multislots_select_slot}
        </p>}
        <div className='map_page--details'>

          {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <HappyHoureTitle />}
          <div className='dealers-listing half-block'>
            <div className='dealers-block-container'>

              {!this.state.isLoading && this.state.selectedData && this.state.selectedData.map(function (item, key) {
                return (<DealerBlock
                  dealerMouseOver={this.dealerIsHover}
                  dealerMouseOut={this.markerNotHover}
                  dealerName={item.Name}
                  dealerID={item.DealerId}
                  dealerGeoId={item.GeoId}
                  dealerAdress={item.Address}
                  SelfReception={item.SelfReception}
                  dealerCity={item.City}
                  dealerZipCode={item.ZipCode}
                  dealerPremServices={item.ListeIdSP}
                  listPremiumServices={this.props.store.listPremiumServices}
                  dealerLCV={item.LCV}
                  dealerPC={item.PC}
                  position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
                  key={item.DealerId}
                  dealerOpen={(this.state.pagination === 1)}
                  ref={'id' + item.DealerId}
                  isPageSolo={true}
                />)
              }.bind(this)
              )}
              {this.state.isLoading && <DealerBlockLoader />}

              {(window.siteConfig.ActivateMOREDEALERSbtn == true) &&
                !this.props.store.isEditMode &&
                <ShowMoreButton onClick={this.showMore} />}
            </div>
          </div>

          <div className='map-block half-block' style={{ top: (!isHappuHoureMessageEnabled ? '0px' : '') }}>
            <MyMapComponent
              loadingElement={<div style={{ height: '100%' }} />}
              containerElement={<div style={{ height: '700px' }} className={'map-container ' + this.state.stickyMap} />}
              mapElement={<div style={{ height: '100%' }} />}
              attDefaultCenter={{ lat: Number(this.state.map.lat), lng: Number(this.state.map.lng) }}
              attOptions={{ mapTypeControl: false, streetViewControl: false }}
              onMapMounted={this.handleMapMounted}
            >
              {this.state.selectedData.map(function (item, key) {
                return <Marker
                  position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
                  title={item.Name}
                  alt={item.Name}
                  icon={(item.IsHover ? new Object({
                    url: _marker.iconActive,
                    size: _marker.size,
                    scaledSize: _marker.scaledSize,
                    origin: _marker.origin
                  })
                    : new Object({
                      url: _marker.icon,
                      size: _marker.size,
                      scaledSize: _marker.scaledSize,
                      origin: _marker.origin
                    }))}
                  onMouseOver={window.siteConfig.currentBrand != 'D' ?
                    (marker) => { this.markerIsHover(item.DealerId) }
                    : ''
                  }
                  onMouseOut={(marker) =>
                    this.markerNotHover()}
                  onClick={(marker) =>
                    this.handleScrollToElement(item.DealerId)}
                  key={item.DealerId}
                />
              }.bind(this)
              )}

            </MyMapComponent>

          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageMapSolo))
